import { css } from 'styled-components';
import { pathOr } from 'ramda';
import {
  FADE_IN_TRANSITION_DURATION,
  FADE_IN_UP_TRANSITION_DURATION,
  TRANSITION_DELAY,
  TRANSITION_DURATION,
} from '../shared/components/animated/animated.constants';

export const TransitionState = {
  ENTERING: 'entering',
  ENTERED: 'entered',
  EXITING: 'exiting',
  EXITED: 'exited',
};

const fadeInStyles = {
  [TransitionState.ENTERING]: css`
    opacity: 0;
  `,
  [TransitionState.ENTERED]: css`
    opacity: 1;
  `,
  [TransitionState.EXITING]: css`
    opacity: 0;
  `,
  [TransitionState.EXITED]: css`
    opacity: 0;
    pointer-events: none;
  `,
};

export const fadeInTransition = css`
  will-change: opacity;
  backface-visibility: hidden;
  transition: opacity ${FADE_IN_TRANSITION_DURATION}ms ease-in;
  ${props => fadeInStyles[pathOr(TransitionState.ENTERED, ['theme', 'transitionState'], props)]};
`;

const fadeInAndUpStyles = {
  [TransitionState.ENTERING]: css`
    transform: translateY(30px);
    opacity: 0;
  `,
  [TransitionState.ENTERED]: css`
    transform: translateY(0px);
    opacity: 1;
  `,
  [TransitionState.EXITING]: css`
    transition: opacity ${FADE_IN_UP_TRANSITION_DURATION}ms ease-in,
      transform ${FADE_IN_UP_TRANSITION_DURATION}ms ease-in;
    transform: translateY(30px);
    opacity: 0;
  `,
  [TransitionState.EXITED]: css`
    opacity: 0;
    pointer-events: none;
  `,
};

//eslint-disable-next-line
const fadeInAndUpTransitionValue = `opacity ${FADE_IN_UP_TRANSITION_DURATION}ms ease-in, transform ${FADE_IN_UP_TRANSITION_DURATION}ms ease-in;`;

export const fadeInAndUpTransition = css`
  transform: translateY(30px);
  will-change: opacity, transform;
  backface-visibility: hidden;
  ${props => fadeInAndUpStyles[pathOr(TransitionState.ENTERED, ['theme', 'transitionState'], props)]};
  transition: ${fadeInAndUpTransitionValue};
`;

const slideFromDownStyles = {
  [TransitionState.ENTERING]: css`
    transform: translateY(100vh);
  `,
  [TransitionState.ENTERED]: css`
    transform: translateY(0);
  `,
  [TransitionState.EXITING]: css`
    transform: translateY(100vh);
  `,
  [TransitionState.EXITED]: css`
    opacity: 0;
    pointer-events: none;
    transform: translateY(100vh);
  `,
};

export const slideFromDownTransition = css`
  will-change: transform;
  backface-visibility: hidden;
  transition: transform ${TRANSITION_DURATION}ms ease-in-out;
  transition-delay: ${TRANSITION_DELAY}ms;
  ${props => slideFromDownStyles[pathOr(TransitionState.ENTERED, ['theme', 'transitionState'], props)]};
`;
